import {Directive, Injectable, Input, Optional, Signal} from "@angular/core";
import {TipoSolicitudSisben} from "../interface/sisben";
import {CreateTramiteRegistroRequest} from "../../../../../tramitantes/src/app/shared/interfaces/liquidacion";
import {
  TramRegistroSolicitudService
} from "../../../../../tramitantes/src/app/services/tramiteRegistroSolicitud.service";
import {firstValueFrom} from "rxjs";
import {IMapperSisben} from "../interface/mapperSisben";
import {FormGroup} from "@angular/forms";
import {IFormEvent} from "lib-base";
import {ICustomComponent} from "../../../../../tramitantes/src/app/shared/interfaces/configuracion";

@Injectable()
@Directive()
export abstract class TramitesSisben {

  @Input() props: Signal<ICustomComponent> | undefined = undefined;

  readonly tipoSolicitud: TipoSolicitudSisben;
  readonly titulo:string;
  protected mapper?: IMapperSisben<any, any>;

  public abstract modificar(event: any): any;

  public abstract eliminar(event: any): any;

  public abstract validate(): boolean;

  public abstract buildParameters(): any;

  public getParams(): string {
    if (!this.props || !this.props().parametros)
      return "";
    const obj = this.buildParameters();
    if (!obj) return "";
    return JSON.stringify(obj);
  }

  protected constructor( titulo:string,
                         tipoSolicitud: TipoSolicitudSisben,
                        protected readonly _trs: TramRegistroSolicitudService,
                       @Optional() mapper?: IMapperSisben<any, any>) {
    this.tipoSolicitud = tipoSolicitud;
    this.titulo = titulo;
    this.mapper = mapper;
  }

  protected getForm(event: IFormEvent): null | FormGroup {
    if (!event?.data) return null;
    const generalControls: any = event.data.form.formGroup.controls;
    return generalControls['pages'] as FormGroup;
  }

  async submitForm(data: CreateTramiteRegistroRequest): Promise<any> {
    return await firstValueFrom(this._trs.createTramiteSolicitud(data));
  }

}
